import React from "react";
import { createRoot } from "react-dom/client";
import { Spin, message } from "antd";
import { WEEKDAY_TYPES } from "../config/setting";
import Toast from "../components/Toast/Toast";

/**
 * YYYY-MM-DD形式 => YYYY年MM月DD日(week)
 * @param {string} dateString - 日付文字列
 * @returns {String} ユーザーに表示するエラーメッセージ
 */
export const createDateMessage = (dateString) => {
  try {
    const week = getConstValue(
      WEEKDAY_TYPES,
      new Date(dateString).getDay(),
      "abbr"
    );
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const dispDate = `${year}年${month}月${day}日(${week})`;

    return dispDate;
  } catch {
    return "";
  }
};

export const showSpinner = () => {
  const spinnerContainer = document.createElement("div");
  spinnerContainer.setAttribute("id", "global-spinner");
  document.body.appendChild(spinnerContainer);
  const root = createRoot(spinnerContainer);
  root.render(<Spin tip="Loading..." size="large" />);
};

export const hideSpinner = () => {
  const spinnerContainer = document.getElementById("global-spinner");
  if (spinnerContainer) {
    const root = createRoot(spinnerContainer);
    root.unmount();
    document.body.removeChild(spinnerContainer);
  }
};

/**
 * 定数から情報取得するための関数
 * @param {Object} types 定数オブジェクト
 * @param {any} searchValue 検索するプロパティの値
 * @param {string} targetKey 取得したいプロパティのキー
 * @returns {any} 条件に一致するプロパティの値、またはnull
 */
export const getConstValue = (types, searchValue, targetKey) => {
  const type = Object.values(types).find((type) => type?.id == searchValue);
  return type ? type[targetKey] : null;
};

/**
 * トースト表示
 * @param {string} content メッセージ内容
 * @param {string} type カラータイプ(sucess or error)
 * @param {string} iconType カラータイプ(check or exclamation)
 * @returns {} なし
 */
export const showToast = (content, type) => {
  const key = `open${Date.now()}`;
  const closeToast = () => {
    message.destroy(key);
  };
  const iconType = type === "success" ? "check" : "exclamation";

  message.open({
    content: <Toast content={content} type={iconType} onClose={closeToast} />,
    key,
    className: `ant-message-notice-content-${type}`,
  });
};

/**
 * 数字または文字列をBase64にエンコード
 * @param {number|string} input
 * @returns {string} Base64エンコードされた文字列
 */
export const encodeToBase64 = (input) => {
  // inputが数字であれば文字列に変換
  const inputString = typeof input === "number" ? input.toString() : input;

  // 文字列をUint8Arrayに変換
  const byteArray = new TextEncoder().encode(inputString);

  // バイト配列をBase64に変換
  const base64String = btoa(String.fromCharCode(...byteArray));

  return base64String;
};
